import { richTextResolver } from "@website-builder/utilities/utils/TransformerHelpers.js";
export default ({ textItems, mobileText }, { globalVariableWithURL = [] }) => {
	return {
		textItems: textItems.map((item) => {
			return {
				size: item?.size / 16 + "rem",
				tag: item?.tag,
				text: richTextResolver(item?.text, globalVariableWithURL) || "",
			};
		}),
		mobileText: richTextResolver(mobileText, globalVariableWithURL) || "",
	};
};
